import { render, staticRenderFns } from "./home_hotspot.vue?vue&type=template&id=6f62658a&scoped=true"
import script from "./home_hotspot.vue?vue&type=script&lang=js"
export * from "./home_hotspot.vue?vue&type=script&lang=js"
import style0 from "./home_hotspot.vue?vue&type=style&index=0&id=6f62658a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f62658a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/crmeb/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f62658a')) {
      api.createRecord('6f62658a', component.options)
    } else {
      api.reload('6f62658a', component.options)
    }
    module.hot.accept("./home_hotspot.vue?vue&type=template&id=6f62658a&scoped=true", function () {
      api.rerender('6f62658a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_hotspot.vue"
export default component.exports